import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Endereço público oficial (versão preferencial, sem "www"). É usado para
// montar a URL canônica de cada rota, mesmo que alguém acesse por "www".
export const SITE_URL = 'https://autorizafoto.com.br';

const TITULO_PADRAO = 'Aplicativo de Autorização de Uso de Imagem | Autoriza Foto';
const DESCRICAO_PADRAO =
  'Aplicativo para fotógrafos colherem a autorização de uso de imagem com assinatura digital no celular. O termo assinado é gerado em PDF e enviado por e-mail.';

// Páginas públicas, com conteúdo próprio, que podem aparecer em buscadores.
// Tudo que NÃO está aqui (telas de cadastro, assinatura, envio, planos,
// administração, links de e-mail…) recebe "noindex": são telas de uso do
// app, de quem já está logado, e não devem aparecer em buscas.
const PAGINAS_PUBLICAS = {
  '/': { titulo: TITULO_PADRAO, descricao: DESCRICAO_PADRAO },
  '/termos': {
    titulo: 'Termos de Uso | Autoriza Foto',
    descricao: 'Termos de Uso do Autoriza Foto, aplicativo de autorização de uso de imagem para fotógrafos.',
  },
  '/privacidade': {
    titulo: 'Política de Privacidade | Autoriza Foto',
    descricao: 'Como o Autoriza Foto trata dados pessoais, conforme a LGPD, na gestão de autorizações de uso de imagem.',
  },
  // Entrada do app e cadastro: podem ser encontrados, mas sem texto próprio
  // relevante para busca; ficam fora do sitemap.
  '/login': {
    titulo: 'Entrar | Autoriza Foto',
    descricao: 'Acesse sua conta de fotógrafo no Autoriza Foto.',
  },
  '/registro': {
    titulo: 'Criar conta | Autoriza Foto',
    descricao: 'Crie sua conta no Autoriza Foto e experimente 7 dias grátis.',
  },
};

function definirMeta(seletor, criar, valor) {
  let el = document.head.querySelector(seletor);
  if (!el) {
    el = document.createElement('meta');
    criar(el);
    document.head.appendChild(el);
  }
  el.setAttribute('content', valor);
}

// Componente sem tela: a cada troca de rota, atualiza título, descrição,
// URL canônica e a diretiva de indexação do <head>. Não depende de nenhuma
// biblioteca externa.
export default function SeoRota() {
  const { pathname } = useLocation();

  useEffect(() => {
    const caminho = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    const pagina = PAGINAS_PUBLICAS[caminho];
    const indexar = !!pagina;
    const titulo = pagina ? pagina.titulo : 'Autoriza Foto';
    const descricao = pagina ? pagina.descricao : DESCRICAO_PADRAO;
    const urlCanonica = SITE_URL + (caminho === '/' ? '/' : caminho);

    document.title = titulo;

    definirMeta('meta[name="description"]', (el) => el.setAttribute('name', 'description'), descricao);
    definirMeta('meta[name="robots"]', (el) => el.setAttribute('name', 'robots'),
      indexar ? 'index, follow' : 'noindex, nofollow');
    definirMeta('meta[property="og:title"]', (el) => el.setAttribute('property', 'og:title'), titulo);
    definirMeta('meta[property="og:description"]', (el) => el.setAttribute('property', 'og:description'), descricao);
    definirMeta('meta[property="og:url"]', (el) => el.setAttribute('property', 'og:url'), urlCanonica);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', urlCanonica);
  }, [pathname]);

  return null;
}
